import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useGetCourtSettingsQuery, useUpdateCourtMutation } from '../../Api/courts';
import useTranslate from '../../Hooks/useTranslate';
import Button from '../../Style-guide/Button';
import ImageSection from './imageSection';
import CourtInputFields from './inputFields/courtInputFields';
import onSubmit from './saveCourtChanges';
import CourtPageWrapper from './style/editCourtPageWrapper';

const courtFields = {
  name: '',
  address: '',
  contacts: '',
  description: '',
  maxDaysAheadToReserve: '',
  priceForSixtyMin: '',
  priceForNinetyMin: '',
};

const EditCourt = () => {
  const { courtId } = useParams();
  const tr = useTranslate();

  const { mutate: updateCourt } = useUpdateCourtMutation();
  const { data: courtData, isSuccess } = useGetCourtSettingsQuery({
    params: { id: courtId },
  });

  const [courtInputs, setCourtInputs] = useState({
    ...courtFields,
  });

  const [inputErrors, setInputErrors] = useState({
    ...courtFields,
  });

  const [schedule, setSchedule] = useState({});

  const [images, setImages] = useState([
    { imageRole: 'mainImage', src: '', previewUrl: '' },
    { imageRole: 'galleryImage1', src: '', previewUrl: '' },
    { imageRole: 'galleryImage2', src: '', previewUrl: '' },
  ]);

  return (
    <CourtPageWrapper>
      <ImageSection
        images={images}
        setImages={setImages}
        data={courtData}
        isSuccess={isSuccess}
      />
      <CourtInputFields
        courtData={courtData}
        courtInputs={courtInputs}
        setCourtInputs={setCourtInputs}
        isSuccess={isSuccess}
        inputErrors={inputErrors}
        schedule={schedule}
        setSchedule={setSchedule}
      />

      <Button
        className='submit-btn'
        onClick={() =>
          onSubmit({
            images,
            courtInputs,
            courtData,
            schedule,
            updateCourt,
            setInputErrors,
            courtId,
            tr,
          })
        }
      >
        {tr('save_changes')}
      </Button>
    </CourtPageWrapper>
  );
};

export default EditCourt;
